module.exports = __webpack_public_path__ + "static/img/Stephen-Crichton.5e2807e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Stephen-Crichton.jpg
// module id = jGGv
// module chunks = 0